<div class="flex flex-col gap-4">
  <app-parse-request-create-step-card>
    @if (state()?.data?.state?.documentUpload === 'COMPLETE') {
      <div class="text-success dark:text-success-darkmode" slot="header-start">
        <ng-icon name="heroCheckCircleSolid" size="30" class="!block" />
      </div>
    } @else {
      <ui-badge
        [iconOnly]="true"
        mode="outlined"
        rounded="full"
        class="flex flex-none"
        slot="header-start"
      >
        1
      </ui-badge>
    }
    <span slot="header-title">
      {{ 'cockpit.parseRequests.createDocuments.title' | transloco }}
    </span>
    <div class="flex gap-2" slot="header-end">
      @if (state()?.data?.state?.documentUpload !== 'EMPTY' && activeStep() !== 'DOCUMENTS') {
        <ui-button
          mode="outlined"
          size="small"
          type="button"
          [routerLink]="['../documents']"
          [relativeTo]="activatedRoute"
          [uiTooltip]="'cockpit.parseRequests.editButtonTitle' | transloco"
        >
          <ng-icon name="heroPencilSquare" size="20" class="!block" slot="start" />
          {{ 'cockpit.parseRequests.editButton' | transloco }}
        </ui-button>
      }
      <a
        [href]="uploadDocumentsInfoButtonLink()"
        target="_blank"
        [title]="'cockpit.parseRequests.createDocuments.infoButtonTitle' | transloco"
        *appFeatureEnabled="'helpCenter'"
      >
        <ui-button [iconOnly]="true" mode="outlined" size="small" type="button">
          <ng-icon name="heroInformationCircle" size="20" class="!block" />
        </ui-button>
      </a>
    </div>

    @if (activeStep() === 'DOCUMENTS') {
      <div class="empty:hidden @container/documents-form" slot="content">
        <ng-content select="[slot='documents-form']"></ng-content>
      </div>
    }
    @if (activeStep() === 'DOCUMENTS') {
      <div class="empty:hidden @container/documents-footer" slot="footer">
        <ng-content select="[slot='documents-footer']"></ng-content>
      </div>
    }
  </app-parse-request-create-step-card>

  <app-parse-request-create-step-card>
    @if (state()?.data?.state?.generalInformation === 'COMPLETE') {
      <div class="text-success dark:text-success-darkmode" slot="header-start">
        <ng-icon name="heroCheckCircleSolid" size="30" class="!block" />
      </div>
    } @else {
      <ui-badge
        [iconOnly]="true"
        mode="outlined"
        rounded="full"
        class="flex flex-none"
        slot="header-start"
      >
        2
      </ui-badge>
    }
    <span slot="header-title">
      {{ 'cockpit.parseRequests.createGeneral.title' | transloco }}
    </span>
    <div class="flex gap-2" slot="header-end">
      @if (state()?.data?.state?.generalInformation !== 'EMPTY' && activeStep() !== 'GENERAL') {
        <ui-button
          mode="outlined"
          size="small"
          type="button"
          [routerLink]="['../general']"
          [relativeTo]="activatedRoute"
          [uiTooltip]="'cockpit.parseRequests.editButtonTitle' | transloco"
        >
          <ng-icon name="heroPencilSquare" size="20" class="!block" slot="start" />
          {{ 'cockpit.parseRequests.editButton' | transloco }}
        </ui-button>
      }
      <a
        [href]="generalInfoButtonLink()"
        target="_blank"
        [title]="'cockpit.parseRequests.createGeneral.infoButtonTitle' | transloco"
        *appFeatureEnabled="'helpCenter'"
      >
        <ui-button [iconOnly]="true" mode="outlined" size="small" type="button">
          <ng-icon name="heroInformationCircle" size="20" class="!block" />
        </ui-button>
      </a>
    </div>

    @if (activeStep() === 'GENERAL') {
      <div class="empty:hidden @container/general-form" slot="content">
        <ng-content select="[slot='general-form']"></ng-content>
      </div>
    }
    @if (activeStep() === 'GENERAL') {
      <div class="empty:hidden @container/general-footer" slot="footer">
        <ng-content select="[slot='general-footer']"></ng-content>
      </div>
    }
  </app-parse-request-create-step-card>

  <app-parse-request-create-step-card>
    <ui-badge
      [iconOnly]="true"
      mode="outlined"
      rounded="full"
      class="flex flex-none"
      slot="header-start"
    >
      3
    </ui-badge>
    <span slot="header-title">
      {{ 'cockpit.parseRequests.createSummary.title' | transloco }}
    </span>
    <div class="flex gap-2" slot="header-end">
      <a
        [href]="summaryInfoButtonLink()"
        target="_blank"
        [title]="'cockpit.parseRequests.createSummary.infoButtonTitle' | transloco"
        *appFeatureEnabled="'helpCenter'"
      >
        <ui-button [iconOnly]="true" mode="outlined" size="small" type="button">
          <ng-icon name="heroInformationCircle" size="20" class="!block" />
        </ui-button>
      </a>
    </div>

    @if (activeStep() === 'SUMMARY') {
      <div class="empty:hidden @container/summary-form" slot="content">
        <ng-content select="[slot='summary-form']"></ng-content>
      </div>
    }
    @if (activeStep() === 'SUMMARY') {
      <div class="empty:hidden @container/summary-footer" slot="footer">
        <ng-content select="[slot='summary-footer']"></ng-content>
      </div>
    }
  </app-parse-request-create-step-card>
</div>
